import menusService from '../../services/menus';
import pickupNumbersService from '../../services/pickupnumbers';
import TimeFormatter from '../../../src/assets/js/TimeFormatter';
import orderbyphonesService from '../../services/orderbyphones';

const state = {
    restaurantId : null,
    restaurantName : '', 
    menus : [],
    isPhoneValid : true,
    currentMenu : {
        menuCategories : [],
        menuItems : []
    },
    cart: {
        selectedItems : [],
        comment : '',
        customerName : '',
        phoneNumber : '',
        pickupNumber : 0,
        totalPrice : 0,
        totalQuantity : 0,
        waitingTime : 20,
        pickupTime : TimeFormatter.getCurrentTime()

    }
}

const getters = {

    getItemsByCategory : (state) => (categoryName) => {
        return state.currentMenu.menuItems.filter(item => item.categoryName === categoryName);
    },
    
    
}

const actions = {

    async getMenusAction(context, id) {
                           
        await menusService.getMenusByRestaurantId(id)
                          .then(response => { context.commit('setMenusState', response) });

    },

    async getPickupNumberAction(context, id) {

        await pickupNumbersService.getPickupNumberByRestaurant(id)
                                  .then(response => { context.commit('setPickupNumberState', response) });

    },

    async createOrderByPhoneAction(context, payload) {
        await orderbyphonesService.createOrderByPhoneService(payload.order);
        context.commit('clearCartState');
    },

    async createOrderByPhoneWithSMSNotificationAction(context, payload) {
        await orderbyphonesService.createOrderByPhoneServiceWithSMSNotification(payload.order);
        context.commit('clearCartState');
    },

    async createOrderByPhoneWithOrderManagerAction(context, payload) {
        await orderbyphonesService.createOrderByPhoneServiceWithOrderManager(payload.order);
        context.commit('clearCartState');
    }

}

const mutations = {
    setMenusState(state, menus) {
        state.menus = menus;
        if (state.menus.length > 0) {
          state.currentMenu = state.menus[0];
        }
    },
    
    setRestaurantIdState (state, id) {
        state.restaurantId = id;
    },

    setRestaurantNameState (state, name) {
        state.restaurantName = name;
    },

    setPickupNumberState( state, pickupNumber ) {
        state.cart.pickupNumber = pickupNumber;
    },

    setCurrentWaitingTimeState(state, waitingTime ) {
        state.cart.waitingTime = waitingTime;
    },

    setPickupTimeState(state, pickupTime) {
        state.cart.pickupTime = pickupTime;
    },

    addItemToCartState (state, item) {
        //
        //Find the item to increase its quantity
        //

        let itemInCart = state.cart.selectedItems.findIndex(i  => 
            item.itemId === i.itemId
        );
  
        if (itemInCart > -1) {
            state.cart.selectedItems[itemInCart].quantity++;
        }
        else {
            let itemToAdd = {
                itemId : item.itemId,
                itemName : item.itemName,
                itemPrice : item.itemPrice,
                tax : item.tax,
                quantity : 1,
                categoryName : item.categoryName
            }
            state.cart.selectedItems.push(itemToAdd);
        }
        state.cart.totalQuantity++;
        state.cart.totalPrice += item.itemPrice;

    },

    clearCartState(state) {
        state.cart.selectedItems.splice(0, state.cart.selectedItems.length);
        state.restaurantId = null;
        state.cart.customerName = '';
        state.cart.phoneNumber = '';
        state.cart.totalPrice = 0.0;
        state.cart.totalQuantity = 0;
        state.cart.comment = '';
    },

    removeItemFromCartState(state, itemId) {
        let index = state.cart.selectedItems.findIndex(i => {
            return i.itemId === itemId;
        });
        if (index > -1) {
            state.cart.totalPrice -= state.cart.selectedItems[index].itemPrice * state.cart.selectedItems[index].quantity;
            state.cart.totalQuantity -= state.cart.selectedItems[index].quantity;
            state.cart.selectedItems.splice(index, 1);
        }
    },
    updateCustomerNameState(state, customer) {
        state.cart.customerName = customer;
    },
    updatePhoneNumberState(state, phone) {
        state.cart.phoneNumber = phone;
    },
    updateIsPhoneValidState(state, isValid) {
        console.log('updateIsPhoneValidState:' + isValid)
        state.isPhoneValid = isValid;
    },
    updateCommentState(state, comment) {
        state.cart.comment = comment;
    },
    updateQuantityState(state, payload) {
        let index = state.cart.selectedItems
                     .findIndex(i => i.itemId === payload.itemId);
        if (index > -1) {
            //
            //Minus current total price and total quantity
            //
            state.cart.totalQuantity -= state.cart.selectedItems[index].quantity;
            state.cart.totalPrice -= state.cart.selectedItems[index].quantity * state.cart.selectedItems[index].itemPrice;

            //
            //update new price and new quantity
            //
            state.cart.selectedItems[index].quantity = payload.quantity;
            state.cart.totalQuantity += payload.quantity;
            state.cart.totalPrice += state.cart.selectedItems[index].quantity * state.cart.selectedItems[index].itemPrice;
        }
    }

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }